import React from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import Menu from "../menu";
import { Table, Pagination, Button, DatePicker, Icon } from "../../components";
import { axios, Globals, ENV } from "../../utils";
import PrinterIcon from '../../assets/icons/printer.png';

const INITIAL_TABLE_MSG = 'Realice una búsqueda para ver los resultados';
const EMPTY_TABLE_MSG = 'No hay registros';

const HEADER = [
  "Fecha/Hora",
  "Usuario",
  "Documento",
  "Valor Anterior",
  "Valor Nuevo",
  "Comando",
  "Justificación",
];

class SeniatGlobalReport extends React.Component {
  state = {
    emptyMessage: INITIAL_TABLE_MSG,
    form: {
      search: "",
      user_id: this.props.user.id,
      seller_id: "",
    },
    dates: {
      minDate: "",
      maxDate: ""
    },
    data: [],
    page: 1,
    last_page: 1,
  };

  abortController = new AbortController();

  componentDidMount() {
    // this.load();
  }

  componentWillUnmount() {
    this.abortController.abort();
  }

  load = async (page = 1) => {
    Globals.setLoading();
    try {
      const res = await axios.post("seniat/reports/global?page=" + page, this.state.form);
      this.setState({
        page,
        emptyMessage: EMPTY_TABLE_MSG,
        last_page: res.data.orders.last_page,
        data: res.data.orders.data,
      });

    } catch (error) {
      console.log(error);
    }
    Globals.quitLoading();
  };

  change = async (value, target) => {
    await this.setState(s => ({ form: { ...s.form, [target]: value } }));
  };

  returnState = async () => {
    await this.setState(state => ({
      ...state,
      emptyMessage: INITIAL_TABLE_MSG,
      data: [],
      page: 1,
      last_page: 1,
      form: {
        search: "",
        user_id: this.props.user.id,
        seller_id: "",
      }
    }));
  };

  print = async () => {
    let { form } = Globals.copy(this.state);
    form.download = true;

    Globals.setLoading();
    try {
      const res = await axios.post('seniat/reports/global', form);
      if (res.data.url_storage) {
        const url = `${ENV.BasePublic}${res.data.url_storage}`;
        const win = window.open(url, "_blank");
        win.focus();

      } else {
        Globals.showError('Ha ocurrido un error');
      }

    } catch (error) {
      console.log(error);
    }
    Globals.quitLoading();
  };

  render() {
    return (
      <Menu history={this.props.history}>
        <div id="global-report">
          <div className="row">
            <div className="col-md-2">
              <DatePicker
                color="white"
                label="Desde"
                className="filter"
                minDate={this.state.dates.minDate}
                value={this.state.form.since}
                onChange={value => this.change(value, 'since')}
              />
            </div>
            <div className="col-md-2">
              <DatePicker
                color="white"
                label="Hasta"
                className="filter"
                maxDate={this.state.dates.maxDate}
                value={this.state.form.until}
                onChange={value => this.change(value, 'until')}
              />
            </div>

            <div className="col-md-4">
              <div className="container-buttons">
                <Button className="btn-align-bottom btn-filter blue" color=" " onClick={() => this.load()}>
                  <span>Filtrar</span>
                </Button>
                <Button className="btn-align-bottom btn-filter" color=" " onClick={this.returnState}>
                  <span>Limpiar</span>
                </Button>
              </div>
            </div>
          </div>

          <Table
            data={this.state.data.length}
            emptyMessage={this.state.emptyMessage}
            header={HEADER}
            right={
              <Button title="Imprimir" small="true" onClick={this.print}>
                <img src={PrinterIcon} alt="Imprimir" />
              </Button>
            }
          >
            {this.state.data.map((i, index) => {
              return (
                <tr key={index}>
                  <td>{ i.date }</td>
                  <td>{ i.user }</td>
                  <td>{ i.document }</td>
                  <td><code>{ i.prev_value }</code></td>
                  <td><code>{ i.new_value }</code></td>
                  <td>
                    {!!i.command && (
                      <Button
                        title="Ver"
                        small="true"
                        onClick={() => Swal.fire({ html: i.command, customClass: "table-popup", showCancelButton: false })}
                        >
                        <Icon name="eye" />
                      </Button>
                    )}
                  </td>
                  <td>
                    {!!i.justification && (
                      <Button
                        title="Ver"
                        small="true"
                        onClick={() => Swal.fire({ html: i.justification, customClass: "table-popup", showCancelButton: false })}
                        >
                        <Icon name="eye" />
                      </Button>
                    )}
                  </td>
                </tr>
              );
            })}
          </Table>

          <Pagination
            pages={this.state.last_page}
            active={this.state.page}
            onChange={this.load}
          />
        </div>
      </Menu>
    );
  }
}

export default connect(state => ({
  user: state.user
}))(SeniatGlobalReport);
